import "core-js/modules/es.array.map";
import React from 'react';

var AccordionContent = function AccordionContent(_ref) {
  var open = _ref.open,
      parentId = _ref.parentId,
      childId = _ref.childId,
      children = _ref.children;
  var contentProps = {
    id: childId,
    role: 'region',
    'aria-labelledby': parentId
  };

  var Content = function Content() {
    return /*#__PURE__*/React.createElement("div", null, React.Children.map(children, function (child) {
      return /*#__PURE__*/React.cloneElement(child, contentProps);
    }));
  };

  return open ? /*#__PURE__*/React.createElement(Content, null) : null;
};

export default AccordionContent;